<sm-title-bar pageTitle="{{ 'previous_employees.title' | translate }}"  [backWithParams]="true">
  </sm-title-bar>
  
  
  <div class="stat-cards row row-cols-xl-4 row-cols-lg-3 g-4" *ngIf="employeeData.length > 0 && !loader">
  
    <div class="col" *ngFor="let item of employeeData">
      <mat-card  appearance="outlined"  class="stats_c">
        <mat-card-title-group class="align-items-center">
          <mat-card-title>{{item.name}}</mat-card-title>
          <mat-card-subtitle class="m-0">{{item.phone}}</mat-card-subtitle>
         
          <mat-card-subtitle style="margin-bottom: 0px; margin-top: 10px;">{{item.addressInfo}}</mat-card-subtitle>
          <mat-card-subtitle class="m-0">DOB: {{item.dob | date}}</mat-card-subtitle>
          <div class="card-icon d-flex justify-content-center align-items-center">
            <!-- <mat-icon color="primary" class="material-icons-outlined">storefront</mat-icon> -->
            <img [src]="item.imgThumbUrl" alt="" onerror="this.src='../../../../assets/images/salon_support_header.png'">
          </div>
        </mat-card-title-group>
      </mat-card>
    </div>
    
   
  </div>


<ng-container *ngIf="employeeData.length == 0 && !loader">
  <!-- <div class="py-5 text-center">
    <h3 class="text-muted">No data found</h3>
  </div> -->
  <div class="merchant_detail_sec"  >
    <div class="mrt_offer">
      <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#b0b0b0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line></svg>
  
      <h3>
        {{ 'previous_employees.text' | translate }}
      </h3>
      <p>
        {{ 'previous_employees.subtext' | translate }}
      </p>
    </div>
  </div>   
</ng-container>